import { GiftPdpDispatch } from '@ff-scene-plugins/gift-redux/store';
import { applyPrefab, selectPrefabs } from './_redux-prefabs';

export const applyPrefabById = (dispatch: GiftPdpDispatch, getState: () => any, prefabId: string) => {
    const state = getState();
    const prefabs = selectPrefabs(state);
    const prefab = prefabs[prefabId];

    if (!prefab) {
        return;
    }

    dispatch(applyPrefab(prefab));
};